module.exports = __webpack_public_path__ + "img/MIV0_capa_familia_3_mercado_PF.d21b44e7.png";